import {
  FeatureToggleConfigurationProperties,
  FeatureToggleContext,
  Kind
} from '@schwab/schwab-feature-toggle-angular';

import { DynamicEnvironment } from '@environment/dynamic-environment';

/**
 * Anonymous startup context. The application drives only global flags (e.g.
 * maintenance mode), so a single shared anonymous context is sufficient; the
 * client-side ID already scopes evaluation to this app and environment.
 * Introduce user-level targeting by keying this context on the signed-in user
 * (via `changeContext()`) when needed.
 */
export function featureToggleStartupContextFactory(): FeatureToggleContext {
  return {
    id: 'shared',
    kind: Kind.User,
    publicMetadata: { anonymous: true }
  };
}

/**
 * Supplies the LaunchDarkly client-side ID (resolved per environment from the
 * runtime config) and startup context to `SchwabFeatureToggleAngularModule`.
 * Evaluated lazily on first injection, after `AppInitService` has loaded
 * `window.config`, so the client-side ID is always available.
 */
export function featureToggleConfigurationPropertiesFactory(): FeatureToggleConfigurationProperties {
  const env = new DynamicEnvironment();

  return {
    clientSideId: env.launchDarklyClientId ?? '',
    startupContext: featureToggleStartupContextFactory()
  };
}
